<script setup lang="ts">
import { computed } from 'vue';
import { pageWindow } from '@/pds/pagination';
import PdsIcon from './PdsIcon.vue';

const props = defineProps<{ page: number; pageCount: number }>();
const emit = defineEmits<{ change: [page: number] }>();

const items = computed(() => pageWindow(props.page, props.pageCount));

const arrow =
  'text-encre flex h-10 w-10 cursor-pointer items-center justify-center rounded-full disabled:cursor-default disabled:opacity-30';
</script>

<template>
  <nav aria-label="Pagination" class="flex items-center gap-1">
    <button
      type="button"
      :class="arrow"
      :disabled="page <= 1"
      aria-label="Page précédente"
      @click="emit('change', page - 1)"
    >
      <PdsIcon name="chevron-left" :size="20" />
    </button>
    <template v-for="(item, index) in items" :key="`${item}-${index}`">
      <span v-if="item === '…'" class="text-encre-douce w-6 text-center">
        …
      </span>
      <button
        v-else
        type="button"
        class="flex h-10 min-w-10 cursor-pointer items-center justify-center rounded-full px-2 text-[14px] font-semibold"
        :class="item === page ? 'bg-encre text-carte' : 'text-encre'"
        :aria-current="item === page ? 'page' : undefined"
        :aria-label="`Page ${item}`"
        @click="emit('change', item)"
      >
        {{ item }}
      </button>
    </template>
    <button
      type="button"
      :class="arrow"
      :disabled="page >= pageCount"
      aria-label="Page suivante"
      @click="emit('change', page + 1)"
    >
      <PdsIcon name="chevron-right" :size="20" />
    </button>
  </nav>
</template>
